const LOCAL_STORAGE_RECENTLY_VIEWED_KEY = 'aquirify-recently-viewed';
const LOCAL_STORAGE_RECENTLY_VIEWED_DELIMITER = ',';
const RECENTLY_VIEWED_GRID_LOADED_CLASS = 'loaded';

const recently_viewed_selectors = {
  grid: '[grid-recently_viewed]',
  productCard: '.product-card-recently_viewed',
};

document.addEventListener('DOMContentLoaded', () => {
  initRecentlyViewedGrid();
});

document.addEventListener('aquirify-recently-viewed:updated', (event) => {
  //console.log('[Shopify Recently Viewed] Recently Viewed Updated ✅', event.detail.recently_viewed);
  initRecentlyViewedGrid();
});

document.addEventListener('aquirify-recently-viewed:init-product-grid', (event) => {
  //console.log('[Shopify Recently Viewed] Recently Viewed Product List Loaded ✅', event.detail.recently_viewed);
});


const fetchRecentlyViewedCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=recently-viewed`;
  //alert(productTileTemplateUrl);
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    //alert(htmlDocument);
    const productCard = htmlDocument.documentElement.querySelector(recently_viewed_selectors.productCard);
    //alert(productCard.outerHTML);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify recently_viewed] Failed to load content for handle: ${handle}`, err));
};

const setupRecentlyViewedGrid = async (grid) => {
  const recently_viewed = getRecentlyViewed();
  const requests = recently_viewed.map(fetchRecentlyViewedCardHTML);
  const responses = await Promise.all(requests);
  const recently_viewedProductCards = responses.join('');
  grid.innerHTML = recently_viewedProductCards;
  grid.classList.add(RECENTLY_VIEWED_GRID_LOADED_CLASS);
  //initRecentlyViewedButtons();

  const event = new CustomEvent('aquirify-recently-viewed:init-product-grid', {
    detail: { recently_viewed: recently_viewed }
  });
  document.dispatchEvent(event);
};

const initRecentlyViewedGrid = () => {
  const grid = document.querySelector(recently_viewed_selectors.grid) || false;
  if (grid) setupRecentlyViewedGrid(grid);
};

const getRecentlyViewed = () => {
  const recently_viewed = localStorage.getItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY) || false;
  if (recently_viewed) return recently_viewed.split(LOCAL_STORAGE_RECENTLY_VIEWED_DELIMITER);
  return [];
};

const setRecentlyViewed = (array) => {
  if(array.length > 4) {
    array.splice(0, 1);
  }
  const recently_viewed = array.join(LOCAL_STORAGE_RECENTLY_VIEWED_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY, recently_viewed);
  //else localStorage.removeItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY);
  //recently_viewed.length = 4;
  const event = new CustomEvent('aquirify-recently-viewed:updated', {
    detail: { recently_viewed: array }
  });
  document.dispatchEvent(event);

  return recently_viewed;
};

const updateRecentlyViewed = (handle) => {
  const recently_viewed = getRecentlyViewed();
  const indexInrecently_viewed = recently_viewed.indexOf(handle);
  if (indexInrecently_viewed === -1) recently_viewed.push(handle);
  //else recently_viewed.splice(indexInrecently_viewed, 1);
  return setRecentlyViewed(recently_viewed);
};

const recentlyviewedContains = (handle) => {
  const recently_viewed = getRecentlyViewed();
  return recently_viewed.includes(handle);
};

const resetRecentlyViewed = () => {
  //return setRecentlyViewed([]);
};
